import { push } from 'connected-react-router';
import { createMiddleware } from '@shared/redux/create-middleware';
import { Routes } from '@domain/router';
import { showSuccessToast, showErrorToast } from '@shared/toasts';
import { SEGMENTED_CONTEXT_NOTIFICATIONS } from './hot-spot.constants';
import {
    DELETE_HOT_SPOT_REQUEST_SUCCEEDED,
    DELETE_HOT_SPOT_REQUEST_FAILED,
    SAVE_HOT_SPOT_REQUEST_SUCCEEDED,
    SAVE_HOT_SPOT_REQUEST_FAILED,
} from './hot-spot-container/hot-spot-container.state';
import { closeHotSpotModal } from './hot-spot-modal/hot-spot-modal.state';

export const hotspotMiddlewares = createMiddleware({
    [DELETE_HOT_SPOT_REQUEST_SUCCEEDED]: () => (
        showSuccessToast({ message: SEGMENTED_CONTEXT_NOTIFICATIONS.DELETE_HOTSPOT.SUCCESSFUL })
    ),
    [DELETE_HOT_SPOT_REQUEST_FAILED]: () => (
        showErrorToast({ message: SEGMENTED_CONTEXT_NOTIFICATIONS.DELETE_HOTSPOT.ERROR })
    ),
    [SAVE_HOT_SPOT_REQUEST_SUCCEEDED]: () => [
        push(Routes.CAMPAIGN_MANAGER),
        showSuccessToast({ message: SEGMENTED_CONTEXT_NOTIFICATIONS.CREATE_HOTSPOT.SUCCESSFUL }),
        closeHotSpotModal(),
    ],
    [SAVE_HOT_SPOT_REQUEST_FAILED]: () => (
        showErrorToast({ message: SEGMENTED_CONTEXT_NOTIFICATIONS.CREATE_HOTSPOT.ERROR })
    ),
});
